import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface PostData {
  userId: number;
  id: number;
  title: string;
  body: string;
}

export const postDataApiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://jsonplaceholder.typicode.com/',
    prepareHeaders: (headers) => {
      headers.set('Authorization', 'Bearer token');
      return headers;
    },
  }),
  endpoints(builders) {
    return {
      fetchPosts: builders.query<PostData[], number | void>({
        query(page = 10) {
          return `posts?_limit=${page}`;
        },
      }),
    };
  },
});

export const { useFetchPostsQuery } = postDataApiSlice;
